import { render } from "./OptionsPanel.vue?vue&type=template&id=0ea0a634&scoped=true&ts=true"
import script from "./OptionsPanel.vue?vue&type=script&lang=ts"
export * from "./OptionsPanel.vue?vue&type=script&lang=ts"

import "./OptionsPanel.vue?vue&type=style&index=0&id=0ea0a634&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea0a634"]])

export default __exports__